import React from "react";
import {encode as base64_encode} from 'base-64';
import { ReactSession } from 'react-client-session';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import queryString from "query-string";
import Select from 'react-select';
import $ from 'jquery';

import {Helpers} from "../config/Helpers";
import {Connection} from "../config/Connection";
import GoogleMap from '../components/GoogleMap';
import AutoComplete from "../components/AutoComplete";

const Marker = props => {
    return <>
        <div className="pin"></div>
        <div className="pulse"></div>
    </>
}

class RegisterByMarketing extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            urlParam: queryString.parse(window.location.search),

            activeTab: 'info',

            dataProduct: [],
            loadingProduct: true,
            productSearch: '',
            productLimit: 50,
            selectedProducts: {},
            vendorPrices: {},
            originalPrices: {},

            dataVendorVisit: [],
            kode_cabang: '',
            kode_supplier: '',
            label: '',

            dataSupplierType: [],
            dataBusinessType: [],
            dataPosition: [],

            mapCenter: {
                lat: -6.213110657838351,
                lng: 106.82010690652227
            },
            mapZoom: 15,
            mapApiLoaded: false,
            mapInstance: null,
            mapApi: null,
            places: [],
            locating: false,

            locPinPoint: '',
            locDistance: '',
            locDistanceDisplay: '',
            locProvinsi: '',
            locKota: '',
            locKecamatan: '',
            locDesa: '',
            locDetails: '',
            locPostalCode: '',
            forcedPostalCode: '',

            supplier_type: '',
            supplier_name: '',
            business_type: '',
            company_name: '',
            company_email: '',
            company_phone: '',
            company_website: '',
            dataBank: [],
            bank_code: '',
            bank_name: '',
            bank_number: '',
            bank_account: '',
            fullname: '',
            position: '',
            phone: '',
            products: '',
            others_products: '',
            description: '',

            isCheckAll: false,
            isMakanan: false,
            isKebutuhanDapur: false,
            isMinuman: false,
            isKebutuhanHotel: false,
            isFurniture: false,
            isJasa: false,
            isEngineer: false,
            isSembako: false,
            isIT: false,
            isOtomotif: false,
            isOther: false,

            arrProducts: [
                {name: 'Makanan', state: 'isMakanan'},
                {name: 'Kebutuhan Dapur', state: 'isKebutuhanDapur'},
                {name: 'Minuman', state: 'isMinuman'},
                {name: 'Kebutuhan Hotel', state: 'isKebutuhanHotel'},
                {name: 'Furniture', state: 'isFurniture'},
                {name: 'Jasa', state: 'isJasa'},
                {name: 'Engineer', state: 'isEngineer'},
                {name: 'Sembako', state: 'isSembako'},
                {name: 'IT', state: 'isIT'},
                {name: 'Otomotif', state: 'isOtomotif'},
                {name: 'Other', state: 'isOther'}
            ]
        }
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = '/login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.prepareData();
            this.getCurrentLocation(false);
        }
    }

    getCurrentLocation = (showError) => {
        if(!navigator.geolocation){
            if(showError){
                toast.error('Browser tidak mendukung geolocation');
            }
            return;
        }

        this.setState({ locating: true });

        navigator.geolocation.getCurrentPosition((position) => {
            this.setState({
                locating: false,
                forcedPostalCode: '',
                mapCenter: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }
            }, () => {
                if(this.state.mapInstance){
                    this.state.mapInstance.setCenter(this.state.mapCenter);
                    this.state.mapInstance.setZoom(17);
                }

                this.googleLocationDetails();
            });
        }, () => {
            this.setState({ locating: false });

            if(showError){
                toast.error('Tidak dapat mengambil lokasi saat ini. Pastikan izin lokasi diaktifkan.');
            }
        });
    };

    getVendorVisit = () => {
        Helpers.getListVendorVisit().then(res => {
            if(res){
                this.setState({
                    dataVendorVisit: res.map(function(item) {
                        return {
                            value: item.KodeCabang,
                            label: (item.KodeCabang === 'Baru') ? item.Label : item.Label + ' - ' + item.Nama,
                            data: item
                        };
                    })
                });
            }
        });
    };

    handleChangeVendorVisit = (event) => {
        if(event.value === 'Baru'){
            this.setState({
                kode_cabang: '',
                kode_supplier: '',
                label: '',
                supplier_type: '',
                supplier_name: '',
                business_type: '',
                company_name: '',
                company_email: '',
                company_phone: '',
                company_website: '',
                bank_code: '',
                bank_name: '',
                bank_number: '',
                bank_account: '',
                fullname: '',
                position: '',
                phone: '',
                others_products: '',
                description: '',
                locPinPoint: '',
                locProvinsi: '',
                locKota: '',
                locKecamatan: '',
                locDesa: '',
                locDetails: '',
                locPostalCode: '',
                forcedPostalCode: '',
                isCheckAll: false,
                isMakanan: false,
                isKebutuhanDapur: false,
                isMinuman: false,
                isKebutuhanHotel: false,
                isFurniture: false,
                isJasa: false,
                isEngineer: false,
                isSembako: false,
                isIT: false,
                isOtomotif: false,
                isOther: false,
                vendorPrices: {}
            }, () => {
                this.getProducts();
            });
        }else{
            const item = event.data;
            let lat = parseFloat(item.Latitude);
            let lng = parseFloat(item.Longitude);

            if((isNaN(lat) || isNaN(lng)) && item.GMaps){
                const match = item.GMaps.match(/[?&]q=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);

                if(match){
                    lat = parseFloat(match[1]);
                    lng = parseFloat(match[2]);
                }
            }

            const savedProducts = (item.products || '').split(',').map(x => x.trim()).filter(Boolean);
            const productState = {};
            this.state.arrProducts.forEach((p) => {
                productState[p.state] = savedProducts.includes(p.name);
            });
            const bank = this.state.dataBank.find(b => b.value === item.bank_code);

            this.setState(Object.assign({
                kode_cabang: item.KodeCabang,
                kode_supplier: item.kode_supplier || '',
                label: item.Label || '',
                supplier_name: item.Nama || '',
                company_name: item.Nama || '',
                company_phone: item.company_phone || '',
                phone: item.Telepon || '',
                locDetails: item.AlamatCabang || '',

                supplier_type: item.supplier_type || '',
                business_type: item.business_type || '',
                company_email: item.company_email || '',
                company_website: item.company_website || '',
                fullname: item.fullname || '',
                position: item.position || '',
                others_products: item.others_products || '',
                description: item.description || '',
                bank_code: item.bank_code || '',
                bank_name: (bank) ? bank.label : '',
                bank_number: item.bank_number || '',
                bank_account: item.bank_account || '',
                locPostalCode: item.postal_code || '',
                forcedPostalCode: item.postal_code || '',
                isCheckAll: false
            }, productState, { vendorPrices: {} }), () => {
                this.getProducts();

                if(!isNaN(lat) && !isNaN(lng)){
                    this.setState({
                        mapCenter: { lat: lat, lng: lng }
                    }, () => {
                        if(this.state.mapInstance){
                            this.state.mapInstance.setCenter(this.state.mapCenter);
                            this.state.mapInstance.setZoom(17);
                        }

                        this.googleLocationDetails();
                    });
                }
            });
        }
    };

    getBank = () => {
        Helpers.getBank().then(res => {
            if(res){
                this.setState({
                    dataBank: res.map(function(item) {
                        return {
                            value: item.KodeBank,
                            label: item.Fullname
                        };
                    })
                });
            }
        });
    };

    handleChangeBank = (event) => {
        this.setState({
            bank_code: event.value,
            bank_name: event.label
        });
    };

    isChecked = (value) => {
        return ['aktif', 't', 'true', 'yes', 'y', '1', 1, true].includes((typeof value === 'string') ? value.trim().toLowerCase() : value);
    };

    getProducts = () => {
        this.setState({ loadingProduct: true });

        Helpers.getProductVendor('', '', 'yes', '', '', this.state.kode_supplier).then(res => {
            const data = (res) ? res : [];
            const selectedProducts = {};
            const vendorPrices = {};

            data.forEach((item) => {
                if(this.isChecked(item.checked)){
                    selectedProducts[item.KodeBarang] = true;
                }

                if(item.kode_product_vendor && item.price !== null && item.price !== undefined && item.price !== ''){
                    vendorPrices[item.KodeBarang] = Math.round(parseFloat(item.price)).toString();
                }
            });

            this.setState({
                dataProduct: data,
                selectedProducts,
                vendorPrices,
                originalPrices: Object.assign({}, vendorPrices),
                loadingProduct: false
            });
        });
    };

    getFilteredProducts = () => {
        const search = this.state.productSearch.trim().toUpperCase();

        if(!search){
            return this.state.dataProduct;
        }

        return this.state.dataProduct.filter((item) => {
            return ['KodeBarang', 'NamaBarang', 'JenisBarang', 'KategoriBarang', 'Produsen'].some((key) => {
                return ((item[key]) ? item[key] : '').toString().toUpperCase().includes(search);
            });
        });
    };

    handleProductSearch = (e) => {
        this.setState({
            productSearch: e.target.value,
            productLimit: 50
        });
    };

    handleVendorPrice = (kode, value) => {
        this.setState({
            vendorPrices: Object.assign({}, this.state.vendorPrices, { [kode]: value })
        });
    };

    toggleProduct = (kode) => {
        const selectedProducts = Object.assign({}, this.state.selectedProducts);

        if(selectedProducts[kode]){
            delete selectedProducts[kode];
        }else{
            selectedProducts[kode] = true;
        }

        this.setState({ selectedProducts });
    };

    prepareData = () => {
        this.getProducts();
        this.getBank();
        this.getVendorVisit();
        this.getMasterData('Master_MP_Supplier_Type','','dataSupplierType','id','name');
        this.getMasterData('Master_MP_Business_Type','','dataBusinessType','id','name');
        this.getMasterData('Master_MP_Position','','dataPosition','id','name');
    };

    getMasterData = (table,id,state,value,label,additional) => {
        Helpers.getMasterData(table,id).then(res => {
            if(res){
                this.setState({
                    [state]: res.map(function(item) {
                        return {
                            additional: (additional) ? item[additional] : null,
                            value: item[value],
                            label: (label instanceof Array) ? label.map(function(val, index) {
                                let setVal = (val.includes("|")) ? item[val.split("|")[0]][val.split("|")[1]].trim() : item[val].trim();
                                return (
                                    index === label.length-1
                                ) ? setVal : setVal + ' - ';
                            }) : item[label].trim()
                        };
                    })
                });
            }
        })
    };

    googleLocationDetails = () => {
        const latlng = this.state.mapCenter.lat + ',' + this.state.mapCenter.lng;

        Helpers.googleLocationDetails(latlng).then(res => {
            this.defaultPlace(res.results[0]);
        });
    };

    handleGenerateMaps = () => {
        const generateMaps = <GoogleMap
            defaultZoom={this.state.mapZoom}
            defaultCenter={this.state.mapCenter}
            bootstrapURLKeys={{
                key: Connection.MAPS_API_KEY,
                libraries: ['places', 'geometry'],
            }}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => this.apiHasLoaded(map, maps)}>
            <Marker lat={parseFloat(this.state.mapCenter.lat)} lng={parseFloat(this.state.mapCenter.lng)} />
        </GoogleMap>

        this.setState({
            generateMaps
        });
    };

    apiHasLoaded = (map, maps) => {
        this.setState({
            mapApiLoaded: true,
            mapInstance: map,
            mapApi: maps,
        });
    };

    findComponent = (place, type) => {
        const found = place.address_components.find(x => x.types[0] === type);
        return (found) ? found.long_name : '';
    };

    defaultPlace = (place) => {
        this.setState({
            places: [place],
            mapCenter: {
                lat: place.geometry.location.lat,
                lng: place.geometry.location.lng
            },
            locPinPoint: place.formatted_address,
            locProvinsi: this.findComponent(place, 'administrative_area_level_1'),
            locKota: this.findComponent(place, 'administrative_area_level_2'),
            locKecamatan: this.findComponent(place, 'administrative_area_level_3'),
            locDesa: this.findComponent(place, 'administrative_area_level_4'),
            locPostalCode: this.state.forcedPostalCode || this.findComponent(place, 'postal_code')
        }, () => {
            this.countDistance();
        });
    };

    addPlace = (place) => {
        this.setState({
            forcedPostalCode: '',
            places: [place],
            mapCenter: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            },
            locPinPoint: place.formatted_address,
            locProvinsi: this.findComponent(place, 'administrative_area_level_1'),
            locKota: this.findComponent(place, 'administrative_area_level_2'),
            locKecamatan: this.findComponent(place, 'administrative_area_level_3'),
            locDesa: this.findComponent(place, 'administrative_area_level_4'),
            locPostalCode: this.findComponent(place, 'postal_code')
        }, () => {
            this.countDistance();
        });
    };

    countDistance = () => {
        const destination = this.state.mapCenter.lat + ',' + this.state.mapCenter.lng
        Helpers.countDistance(destination,(typeof this.state.branchCode === 'undefined') ? 'CBNG-18-020001' : this.state.branchCode).then(res => {
            $(".loader-wrapper").css("display", "none");
            this.setState({
                locDistance: res[0].distanceValue,
                locDistanceDisplay: res[0].distanceText + ' / ' + res[0].durationText,
            }, () => {
                this.handleGenerateMaps();
            });
        })
    };

    handleChange = (event,state) => {
        this.setState({ [state]: event.value });
    };

    handleChecked = (state) => {
        if(state === 'isCheckAll'){
            const checked = !this.state.isCheckAll;

            this.setState({
                isCheckAll: checked,
                isMakanan: checked,
                isKebutuhanDapur: checked,
                isMinuman: checked,
                isKebutuhanHotel: checked,
                isFurniture: checked,
                isJasa: checked,
                isEngineer: checked,
                isSembako: checked,
                isIT: checked,
                isOtomotif: checked,
                isOther: false
            });
        }else{
            this.setState({
                [state]: !this.state[state]
            });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();

        $(".loader-wrapper").css("display", "");

        const latlng = this.state.mapCenter.lat + ',' + this.state.mapCenter.lng;
        let getProduct = '';
        for(var i=0; i<this.state.arrProducts.length; i++){
            if(this.state[this.state.arrProducts[i].state]){
                getProduct = (getProduct) ? getProduct+','+this.state.arrProducts[i].name : this.state.arrProducts[i].name;
            }
        }

        Helpers.manageVendorByMarketing(
            this.state.kode_cabang,
            this.state.sessUserCode,
            this.state.sessUserCode,
            this.state.kode_supplier,
            encodeURIComponent(this.state.label),
            this.state.supplier_type,
            encodeURIComponent(this.state.supplier_name),
            this.state.business_type,
            encodeURIComponent(this.state.company_name),
            this.state.company_email,
            this.state.company_phone,
            this.state.company_website,
            encodeURIComponent(this.state.fullname),
            this.state.position,
            this.state.phone,
            getProduct,
            encodeURIComponent(this.state.others_products),
            encodeURIComponent(this.state.description),
            this.state.locPostalCode,
            this.state.locDesa,
            this.state.locKecamatan,
            this.state.locKota,
            this.state.locProvinsi,
            encodeURIComponent(this.state.locDetails),
            this.state.locPinPoint,
            latlng,
            'insert',
            encodeURIComponent(this.state.bank_name),
            this.state.bank_code,
            encodeURIComponent(this.state.bank_number),
            encodeURIComponent(this.state.bank_account)
        ).then(res => {
            if(res && res.length > 0){
                if(res[0].alert == 'success'){
                    toast.success(res[0].message);

                    this.saveVendorProducts().then(result => {
                        $(".loader-wrapper").css("display", "none");

                        if(result.error){
                            toast.warning(result.error);
                        }else if(result.failed > 0){
                            toast.error(result.failed + ' produk gagal disimpan, ' + result.success + ' berhasil. Silakan periksa lalu kirim ulang.');
                        }else{
                            if(result.success > 0){
                                toast.success(result.success + ' produk vendor disimpan');
                            }

                            setTimeout(function() {
                                window.location.href = '/vendor';
                            }, 1000);
                        }
                    });
                }else{
                    $(".loader-wrapper").css("display", "none");
                    toast[res[0].alert](res[0].message);
                }
            }else{
                $(".loader-wrapper").css("display", "none");
                toast.error(Helpers.MSG_ERROR);
            }
        })
    };

    // insert: belum punya kode_product_vendor & dicentang
    // update: punya kode_product_vendor & dicentang
    // delete: punya kode_product_vendor & sebelumnya dicentang lalu dilepas
    buildProductActions = () => {
        const actions = [];

        this.state.dataProduct.forEach((item) => {
            const checked = !!this.state.selectedProducts[item.KodeBarang];
            const wasChecked = this.isChecked(item.checked);
            const price = (this.state.vendorPrices[item.KodeBarang] || '').toString().replace(/\D/g, '');
            const priceChanged = !!price && price !== (this.state.originalPrices[item.KodeBarang] || '');

            if(item.kode_product_vendor){
                if(!checked && wasChecked){
                    actions.push({ kode_product: item.kode_product_vendor, steps: [{ command: 'delete', unit: '', price: '' }] });
                }else if(checked && !wasChecked){
                    const steps = [{ command: 'active', unit: '', price: '' }];

                    if(priceChanged){
                        steps.push({ command: 'update', unit: item.KodeUnitBesar, price: price });
                    }

                    actions.push({ kode_product: item.kode_product_vendor, steps });
                }else if(checked && priceChanged){
                    actions.push({ kode_product: item.kode_product_vendor, steps: [{ command: 'update', unit: item.KodeUnitBesar, price: price }] });
                }
            }else if(checked){
                actions.push({ kode_product: '', steps: [{ command: 'insert', unit: item.KodeUnitBesar, price: price }] });
            }
        });

        return actions;
    };

    resolveVendor = () => {
        if(this.state.kode_supplier){
            return Promise.resolve({ kode_cabang: this.state.kode_cabang, kode_supplier: this.state.kode_supplier });
        }

        const known = this.state.dataVendorVisit.map(x => x.value);

        return Helpers.getListVendorVisit().then(res => {
            const created = (res || []).filter(x => !known.includes(x.KodeCabang));
            const match = created.find(x => x.Label === this.state.label && x.Nama === this.state.company_name) || created[0];

            return (match && match.kode_supplier) ? { kode_cabang: match.KodeCabang, kode_supplier: match.kode_supplier } : null;
        });
    };

    saveVendorProducts = () => {
        const actions = this.buildProductActions();

        if(actions.length === 0){
            return Promise.resolve({ success: 0, failed: 0 });
        }

        return this.resolveVendor().then(vendor => {
            if(!vendor){
                return { error: 'Data vendor tersimpan, tetapi kode supplier tidak ditemukan sehingga produk belum disimpan.' };
            }

            this.setState({ kode_cabang: vendor.kode_cabang, kode_supplier: vendor.kode_supplier });

            let index = 0;
            let success = 0;
            let failed = 0;

            const worker = async () => {
                while(index < actions.length){
                    const action = actions[index++];
                    let ok = true;

                    for(const step of action.steps){
                        const res = await Helpers.manageMPProducts(
                            this.state.sessUserCode,
                            action.kode_product,
                            vendor.kode_supplier,
                            encodeURIComponent(step.unit),
                            step.price,
                            '',
                            step.command
                        );

                        if(!(res && res.length > 0 && res[0].alert === 'success')){
                            ok = false;
                            break;
                        }
                    }

                    if(ok){
                        success++;
                    }else{
                        failed++;
                    }
                }
            };

            return Promise.all([worker(), worker(), worker(), worker(), worker()]).then(() => {
                this.getVendorVisit();
                this.getProducts();

                return { success, failed };
            });
        });
    };

    renderProductTab = () => {
        const filtered = this.getFilteredProducts();
        const visible = filtered.slice(0, this.state.productLimit);

        return (
            <>
                <div className="mb-2">
                    <input type="text" placeholder="Cari produk (nama, kode, jenis, produsen)" className="form-control"
                           value={this.state.productSearch} onChange={this.handleProductSearch}
                           onKeyDown={e => {if(e.key === 'Enter'){e.preventDefault();}}}/>
                </div>
                <div className="mb-2 text-muted">
                    {filtered.length} produk ditemukan, {Object.keys(this.state.selectedProducts).length} dipilih
                </div>

                {
                    this.state.loadingProduct ? (
                        <p>Memuat produk...</p>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover align-middle">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th>Produk</th>
                                        <th>Unit</th>
                                        <th>Harga Grosir</th>
                                        <th style={{minWidth: '160px'}}>Harga Jual Vendor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        visible.map((item) => (
                                            <tr key={item.KodeBarang} style={{cursor: 'pointer'}} onClick={() => {this.toggleProduct(item.KodeBarang)}}>
                                                <td style={{width: '40px'}}>
                                                    <input type="checkbox" className="form-check-input"
                                                           checked={!!this.state.selectedProducts[item.KodeBarang]}
                                                           onClick={e => e.stopPropagation()}
                                                           onChange={() => {this.toggleProduct(item.KodeBarang)}}/>
                                                </td>
                                                <td style={{width: '60px'}}>
                                                    <img src={item.img_url} alt="" width="48" height="48" style={{objectFit: 'contain'}}/>
                                                </td>
                                                <td>
                                                    <strong>{item.NamaBarang}</strong>
                                                    <div className="text-muted" style={{fontSize: '12px'}}>
                                                        {item.KodeBarang} · {item.JenisBarang}{item.Produsen ? ' · ' + item.Produsen : ''}
                                                    </div>
                                                </td>
                                                <td>{item.UnitBesar}</td>
                                                <td style={{whiteSpace: 'nowrap'}}>Rp {item.HargaGrosirBesar}</td>
                                                <td onClick={e => e.stopPropagation()}>
                                                    <input type="text" placeholder="Harga jual" className="form-control form-control-sm"
                                                           value={this.state.vendorPrices[item.KodeBarang] || ''}
                                                           onChange={e => this.handleVendorPrice(item.KodeBarang, e.target.value)}
                                                           onKeyDown={e => {if(e.key === 'Enter'){e.preventDefault();}}}/>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    {
                                        filtered.length === 0 && (
                                            <tr><td colSpan="6" className="text-center text-muted">Produk tidak ditemukan</td></tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    )
                }

                {
                    filtered.length > visible.length && (
                        <button type="button" className="btn btn-sm btn-outline-primary"
                                onClick={() => {this.setState({productLimit: this.state.productLimit + 50})}}>
                            Tampilkan lebih banyak ({filtered.length - visible.length} lagi)
                        </button>
                    )
                }
            </>
        );
    };

    renderCheckbox = (item) => {
        return (
            <label className="form-check mt-1" key={item.state}>
                <input type="checkbox" className="form-check-input"
                       checked={this.state[item.state]}
                       onChange={() => {this.handleChecked(item.state)}}/>
                <span className="form-check-label">{item.name}</span>
            </label>
        );
    };

    render() {
        const products = this.state.arrProducts.filter(item => item.state !== 'isOther');
        const half = Math.ceil(products.length / 2);

        return (
            <>
                <ToastContainer />

                <div className="loader-wrapper" style={{'display': 'none'}}>
                    <div className="loader"></div>
                </div>

                <main>
                    <header className="main-header style-2 navbar">
                        <div className="col-brand">
                            <a href="/" className="brand-wrap">
                                <img src={'./../'+Helpers.IMG_LOGO} className="logo" alt="Nest Dashboard"/>
                            </a>
                        </div>
                    </header>
                    <section className="content-main">
                        <div className="card">
                            <div className="card-body">
                                <form method="post" onSubmit={(e) => {this.handleSubmit(e)}}
                                      onInvalidCapture={() => {if(this.state.activeTab !== 'info'){this.setState({activeTab: 'info'});}}}>
                                    <h3 className="mb-15">Pendaftaran Vendor</h3>

                                    <nav className="nav nav-pills mb-4" style={{gap: '8px', borderBottom: '1px solid #e8eaed', paddingBottom: '14px'}}>
                                        <a className={(this.state.activeTab === 'info') ? 'nav-link active' : 'nav-link'}
                                           style={{padding: '8px 20px', borderRadius: '20px', fontWeight: 600}}
                                           href="javascript:void(0);" onClick={() => {this.setState({activeTab: 'info'})}}>
                                            Informasi Vendor
                                        </a>
                                        <a className={(this.state.activeTab === 'product') ? 'nav-link active' : 'nav-link'}
                                           style={{padding: '8px 20px', borderRadius: '20px', fontWeight: 600}}
                                           href="javascript:void(0);" onClick={() => {this.setState({activeTab: 'product'})}}>
                                            Produk Dijual{(Object.keys(this.state.selectedProducts).length > 0) ? ' (' + Object.keys(this.state.selectedProducts).length + ')' : ''}
                                        </a>
                                    </nav>

                                    <div style={{display: (this.state.activeTab === 'info') ? '' : 'none'}}>

                                    <h5 className="mb-2">Informasi Perusahaan</h5>
                                    <div className="mb-2">
                                        <label className="form-label">Cabang</label>
                                        <Select
                                            placeholder="Pilih..."
                                            noOptionsMessage={() => "Tidak ada pilihan"}
                                            options={this.state.dataVendorVisit}
                                            value={this.state.dataVendorVisit.filter((item) => item.value === (this.state.kode_cabang || 'Baru'))}
                                            onChange={this.handleChangeVendorVisit} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Label</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required
                                               value={this.state.label} onChange={e => this.setState({label: e.target.value})}/>
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Tipe Vendor</label>
                                        <Select
                                            placeholder="Pilih..."
                                            noOptionsMessage={() => "Tidak ada pilihan"}
                                            options={this.state.dataSupplierType}
                                            value={this.state.dataSupplierType.filter((item) => item.value === this.state.supplier_type)}
                                            onChange={event => this.handleChange(event,'supplier_type')} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Nama Vendor</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required
                                               value={this.state.supplier_name} onChange={e => this.setState({supplier_name: e.target.value})}/>
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Jenis Usaha</label>
                                        <Select
                                            placeholder="Pilih..."
                                            noOptionsMessage={() => "Tidak ada pilihan"}
                                            options={this.state.dataBusinessType}
                                            value={this.state.dataBusinessType.filter((item) => item.value === this.state.business_type)}
                                            onChange={event => this.handleChange(event,'business_type')} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Nama Perusahaan</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required
                                               value={this.state.company_name} onChange={e => this.setState({company_name: e.target.value})}/>
                                    </div>
                                    <div>
                                        <button type="button" className="btn btn-sm btn-outline-primary mb-2"
                                                disabled={this.state.locating}
                                                onClick={() => {this.getCurrentLocation(true)}}>
                                            <i className="material-icons md-my_location"></i> {this.state.locating ? 'Mencari lokasi...' : 'Gunakan Lokasi Saat Ini'}
                                        </button>
                                        {
                                            this.state.mapApiLoaded && (
                                                <AutoComplete map={this.state.mapInstance} mapApi={this.state.mapApi} addplace={this.addPlace} />
                                            )
                                        }
                                        <div style={{ height: '100vh', width: '100%' }}>
                                            {this.state.generateMaps}
                                        </div>
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Provinsi</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required readOnly={true}
                                               value={this.state.locProvinsi} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Kota/Kabupaten</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required readOnly={true}
                                               value={this.state.locKota} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Kecamatan</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required readOnly={true}
                                               value={this.state.locKecamatan} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Kelurahan</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required readOnly={true}
                                               value={this.state.locDesa} />
                                    </div>
                                    <div className="mb-2 mt-2">
                                        <label className="form-label">Kode Pos</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required
                                               value={this.state.locPostalCode} onChange={e => this.setState({locPostalCode: e.target.value})}/>
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Detail Alamat</label>
                                        <textarea className="form-control" rows="3" required
                                                  value={this.state.locDetails} onChange={e => this.setState({locDetails: e.target.value})} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Email Perusahaan</label>
                                        <input type="email" placeholder="Ketik di sini" className="form-control" required
                                               value={this.state.company_email} onChange={e => this.setState({company_email: e.target.value})}/>
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Nomor Telepon Perusahaan</label>
                                        <input type="number" placeholder="Ketik di sini" className="form-control" required
                                               value={this.state.company_phone} onChange={e => this.setState({company_phone: e.target.value})}/>
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Website (opsional)</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control"
                                               value={this.state.company_website} onChange={e => this.setState({company_website: e.target.value})}/>
                                    </div>

                                    <h5 className="mb-2 mt-15">Rekening Bank</h5>
                                    <div className="mb-2">
                                        <label className="form-label">Nama Bank</label>
                                        <Select
                                            placeholder="Pilih..."
                                            noOptionsMessage={() => "Tidak ada pilihan"}
                                            options={this.state.dataBank}
                                            value={this.state.dataBank.filter((item) => item.value === this.state.bank_code)}
                                            onChange={this.handleChangeBank} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Nomor Rekening</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control"
                                               value={this.state.bank_number} onChange={e => this.setState({bank_number: e.target.value})}/>
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Nama Pemilik Rekening</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control"
                                               value={this.state.bank_account} onChange={e => this.setState({bank_account: e.target.value})}/>
                                    </div>

                                    <h5 className="mb-2 mt-15">Informasi Kontak</h5>
                                    <div className="mb-2">
                                        <label className="form-label">Nama Lengkap</label>
                                        <input type="text" placeholder="Ketik di sini" className="form-control" required
                                               value={this.state.fullname} onChange={e => this.setState({fullname: e.target.value})}/>
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Jabatan di Perusahaan</label>
                                        <Select
                                            placeholder="Pilih..."
                                            noOptionsMessage={() => "Tidak ada pilihan"}
                                            options={this.state.dataPosition}
                                            value={this.state.dataPosition.filter((item) => item.value === this.state.position)}
                                            onChange={event => this.handleChange(event,'position')} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label">Nomor Handphone</label>
                                        <input type="number" placeholder="Ketik di sini" className="form-control" required
                                               value={this.state.phone} onChange={e => this.setState({phone: e.target.value})}/>
                                    </div>

                                    <h5 className="mb-2 mt-15">Produk apa yang ditawarkan perusahaan</h5>
                                    <div className="mb-2">
                                        <label className="form-check">
                                            <input type="checkbox" className="form-check-input"
                                                   checked={this.state.isCheckAll}
                                                   onChange={() => {this.handleChecked('isCheckAll')}}/>
                                            <span className="form-check-label">Pilih semua yang sesuai</span>
                                        </label>
                                        <div className="row ml-15 mb-2">
                                            <div className="col-lg-6">
                                                {products.slice(0, half).map(this.renderCheckbox)}
                                            </div>
                                            <div className="col-lg-6">
                                                {products.slice(half).map(this.renderCheckbox)}
                                            </div>
                                        </div>
                                        <label className="form-check mb-2">
                                            <input type="checkbox" className="form-check-input"
                                                   checked={this.state.isOther}
                                                   onChange={() => {this.handleChecked('isOther')}}/>
                                            <span className="form-check-label">Lainnya</span>
                                        </label>
                                        <input type="text" placeholder="Deskripsi Produk/Jasa" className="form-control" readOnly={(this.state.isOther) ? false : true}
                                               value={this.state.others_products} onChange={e => this.setState({others_products: e.target.value})}/>
                                    </div>

                                    <h5 className="mb-2 mt-15">Tulis deskripsi singkat tentang usaha</h5>
                                    <div className="mb-2">
                                        <textarea className="form-control" rows="3" required
                                                  value={this.state.description} onChange={e => this.setState({description: e.target.value})} />
                                    </div>

                                    </div>

                                    <div style={{display: (this.state.activeTab === 'product') ? '' : 'none'}}>
                                        {this.renderProductTab()}
                                    </div>

                                    <button className="btn btn-primary mt-15" type="submit">Kirim</button>
                                </form>
                            </div>
                        </div>
                    </section>
                </main>
            </>
        );
    }
}

export default RegisterByMarketing;
